import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaEye, FaEdit, FaTrash } from "react-icons/fa";
import { formatDate } from "../../../Utils/formatters";
import { useDispatch, useSelector } from "react-redux";
import { openProductModal } from "../../../redux/features/productModalSlice";
import { PAYMENT_STATUS_BADGE } from "../../../Constant/leadConstent";
import Search from "../../../common/Search";
import {
  PurchaseList,
  DeletePurchase,
  PurchaseChangeStatus,
} from "../../../redux/services/PurchaseService/purchase.Services";
import Pagination from "../../../common/Pagination";
import Swal from "sweetalert2";
function AllPurchaseList() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [totalRecords, setTotalRecords] = useState(0);
  const [purchase, setPurchase] = useState([]);
  const [limit, setLimit] = useState(100);
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [selectedIds, setSelectedIds] = useState([]);
  const refreshData = useSelector((state) => state.productModal.refreshData);

  const [loading, setLoading] = useState(false);
  const fetchPurchase = async () => {
    try {
      setLoading(true);

      const payload = {
        page,
        search,
        status,
      };
      const res = await PurchaseList(payload);
      setPurchase(res?.data || []);
      setLastPage(res?.last_page || 1);
      setTotalRecords(res?.total || 0);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPurchase();
  }, [page, search, status, refreshData]);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= lastPage) {
      setPage(newPage);
    }
  };
  const handleCheckboxChange = (id) => {
    setSelectedIds((prev) => (prev.includes(id) ? [] : [id]));
  };
  return (
    <div>
      <div className="d-md-flex d-block align-items-center justify-content-between mt-1 page-header-breadcrumb">
        <div className="d-flex justify-content-between align-items-center w-100">
          <div className="page-header">
            <div>
              <h3 className="page-title">Purchase List</h3>
              <nav className="page-breadcrumb">
                <Link to="/">Home</Link>
                <span className="mx-2">/</span>
                <span>All Purchase </span>
              </nav>
            </div>
          </div>
          <div className="d-flex flex-wrap gap-2 justify-content-end">


            {/* <button
                                      className="btn btn-primary btn-sm"
                                      onClick={handleToggleFilter}
                                  >
                                      <i className="fas fa-filter me-1"></i>
                                      {showFilter ? "Hide Filter" : "Filter"}
                                  </button> */}

            <button
              onClick={() => navigate("/add-purchase")}
              className="lead-btn btn-add"
            >
              Add Purchase
            </button>

            {selectedIds.length > 0 && (
              <button
                className="lead-btn btn-import"
                onClick={() =>
                  dispatch(
                    openProductModal({
                      type: "payment-mode",
                      title: "Update Payment",
                      data: {
                        purchase_ids: selectedIds,
                        refreshData: () => {
                          fetchPurchase();
                          setSelectedIds([]);
                        },
                      },
                    })
                  )
                }
              >
                Payment
              </button>
            )}


          </div>







          {/* 

          <button
            className="add-btn"
            onClick={() =>
              // dispatch(
              //   openProductModal({
              //     type: "create-purchase",
              //     title: "Create Purchase",
              //     data: {
              //       refreshData: fetchPurchase,
              //     },
              //   }),
              // )
              navigate("/add-purchase")
            }
          >
            + Add Purchase
          </button>

          <button
            className="add-btn"
            onClick={(item) =>
              dispatch(
                openProductModal({
                  type: "payment-mode",
                  title: "Update Payment",
                  data: {
                    ...item,
                    refreshData: fetchPurchase,
                  },
                })
              )
            }
          >
            Payment
          </button> */}
        </div>
      </div>
      <div className="main_page">
        {(totalRecords > 0 || search) && (
          <div className="d-flex justify-content-end align-items-center mx-2 mb-2">
            <Search
              search={search}
              placeholder="Search Purchase..."
              onSearch={(value) => {
                setSearch(value);
                setPage(1);
              }}
            />
          </div>
        )}

        <div className="st-wrapper-card text-center">
          <div className="st-table-responsive">
            <table className="table st-custom-table align-middle mb-0">
              <thead>
                <tr>
                  <th></th>
                  <th>Sr</th>
                  <th>Date&Time</th>
                  <th>Invoice No</th>
                  <th>Supplyer Name</th>

                  <th>Amount</th>
                  <th>Payment Status</th>
                  {/* <th>Change Status</th> */}
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {purchase.length > 0 ? (
                  purchase.map((item, index) => (
                    <tr key={item.id}>
                      <td>
                        <input
                          type="checkbox"
                          checked={selectedIds.includes(item.id)}
                          onChange={() => handleCheckboxChange(item.id)}
                        />
                      </td>

                        <td> {(page - 1) * limit + index + 1}</td>
                      <td>{formatDate(item.purchase_date)}</td>
                      <td>{item.invoice_no}</td>
                      <td>{item.supplier_details?.supplier_name || "-"}</td>
                      <td>
                        <strong>₹{Number(item.total_amount).toLocaleString()}</strong>
                      </td>
                      <td>
                        <span
                          className={`status-badge ${PAYMENT_STATUS_BADGE[item.payment_status?.toLowerCase()] || "badge-gray"
                            }`}
                        >
                          {item.payment_status}
                        </span>
                      </td>
                      {/* <td>
                        <button
                          className="st-action-btn st-edit-btn"
                          onClick={() =>
                            dispatch(
                              openProductModal({
                                type: "payment-mode",
                                title: "Update Payment",
                                data: {
                                  ...item,
                                  refreshData: fetchPurchase,
                                },
                              })
                            )
                          }
                        >
                          <FaEdit />
                        </button>
                      </td> */}
                      <td className="text-center">
                        <div className="d-flex align-items-center justify-content-center gap-1">
                          <button
                            className="st-action-btn st-view-btn"
                            onClick={() => navigate(`/purchase-product-list/${item.id}`)}
                          >
                            <FaEye />
                          </button>

                          <button
                            className="st-action-btn st-edit-btn"
                            onClick={() =>
                              dispatch(
                                openProductModal({
                                  type: "edit-purchase",
                                  title: "Edit Purchase",
                                  data: {
                                    ...item,
                                    refreshData: fetchPurchase,
                                  },
                                })
                              )
                            }
                          >
                            <FaEdit />
                          </button>

                          {/* Delete */}
                          <button
                            className="st-action-btn st-delete-btn"
                            onClick={() =>
                              dispatch(
                                openProductModal({
                                  type: "delete-purchase",
                                  title: "Delete Purchase",
                                  data: {
                                    id: item.id,
                                    deleteFunction: DeletePurchase,
                                    refreshData: fetchPurchase,
                                  },
                                })
                              )
                            }
                          >
                            <FaTrash />
                          </button>

                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className="text-center py-5">
                      <h5>No Data Found</h5>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            {lastPage > 1 && (
              <div className="d-flex justify-content-end mt-3">
                <Pagination
                  page={page}
                  totalPages={lastPage}
                  onPageChange={handlePageChange}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AllPurchaseList;
